import React from 'react';
import {
  Stack, Icon, Text, withTranslation,
} from '@piwikpro/ui-components';

export const InlineError = withTranslation('administration')(({ t }) => (
  <Stack fullWidth spacing="narrow">
    <Stack.Item>
      <Icon name="exclamation-mark-circle" color="red" />
    </Stack.Item>
    <Stack.Item>
      <Text color="Red" dataId="TextStyle">
        <div style={{ marginBottom: '2px' }}>
          {t('general-errors.inline-error.text')}
        </div>
      </Text>
    </Stack.Item>
  </Stack>
));
